import { FC, ReactNode, createContext, useContext, useState } from 'react'

type NavContextType = {
  items: HTMLElement[]
  setItems: React.Dispatch<React.SetStateAction<HTMLElement[]>>
  visibleItem: HTMLElement | null
  setVisibleItem: (el: HTMLElement) => void
}

export const NavContext = createContext<NavContextType | null>(null)

export const NavContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [items, setItems] = useState<HTMLElement[]>([])
  const [visibleItem, setVisibleItem] = useState<HTMLElement | null>(null)

  return (
    <NavContext.Provider
      value={{ items, setItems, visibleItem, setVisibleItem }}
    >
      {children}
    </NavContext.Provider>
  )
}

export const useNavContext = () => {
  const context = useContext(NavContext)
  return context as NavContextType
}
